import { useToast } from "@chakra-ui/react";
export const useSuccessToast = (options = {}) => {
    const toast = useToast(Object.assign({ status: "success" }, options));
    return toast;
};
//# sourceMappingURL=useSuccessToast.js.map